"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FieldsForm = void 0;
var _react = _interopRequireWildcard(require("react"));
var _bricksUtils = require("@titelmedia/bricks-utils");
var _bricksTheme = _interopRequireDefault(require("@titelmedia/bricks-theme"));
var _styles = require("./styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const FieldsForm = ({
  logo,
  endPoint,
  submitText,
  successMessage,
  consentMessage,
  optInOption,
  optInMessage,
  backgroundColor,
  buttonColor,
  buttonTextColor,
  textColor,
  borderColor
}) => {
  const formRef = (0, _react.useRef)(null);
  const [result, setResult] = (0, _react.useState)('');
  const [isChecked, setIsChecked] = (0, _react.useState)(false);
  const [isOptedIn, setIsOptedIn] = (0, _react.useState)(false);
  const fluid = logo?.fluid || logo?.responsiveImage || logo || null;
  const fields = [{
    name: 'name',
    label: 'NAME',
    ref: (0, _react.useRef)(null),
    pattern: /^[a-zA-Z\s]*$/,
    errorMessage: 'Only letters and spaces are allowed'
  }, {
    name: 'email',
    label: 'EMAIL',
    ref: (0, _react.useRef)(null),
    pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    errorMessage: 'Invalid email address'
  }];
  const handleInputBlur = ref => {
    if (ref.current && ref.current.value === '') {
      _bricksUtils.gsap.to(ref.current.previousSibling, {
        y: 0,
        fontSize: '14px',
        duration: 0.3
      });
    }
  };
  const handleInputChange = ref => {
    if (ref.current && ref.current.value !== '') {
      _bricksUtils.gsap.to(ref.current.previousSibling, {
        y: -20,
        fontSize: '12px',
        duration: 0.3
      });
    }
  };
  const handleConsentChange = () => {
    setIsChecked(!isChecked);
  };
  const handleOptInChange = () => {
    setIsOptedIn(!isOptedIn);
  };
  const resetLabelPositions = () => {
    fields.forEach(field => {
      _bricksUtils.gsap.to(field.ref.current.previousSibling, {
        y: 0,
        fontSize: '14px',
        duration: 0.3
      });
    });
  };
  const handleSubmit = async event => {
    event.preventDefault();
    if (!isChecked) {
      setResult('Please provide consent before submitting.');
      return;
    }
    const data = new FormData(event.target);
    try {
      const response = await fetch(endPoint, {
        method: 'POST',
        body: data,
        headers: {
          Accept: 'application/json'
        }
      });
      if (response.ok) {
        setResult(successMessage);
        formRef.current.reset();
        resetLabelPositions();
        setIsChecked(false);
        setIsOptedIn(false);
      } else {
        const errorData = await response.json();
        if (errorData.errors) {
          setResult(errorData.errors.map(error => error.message).join(', '));
        } else {
          setResult('Oops! There was a problem submitting your form');
        }
      }
    } catch (error) {
      setResult('Oops! There was a problem submitting your form');
    }
  };
  (0, _react.useEffect)(() => {
    return () => resetLabelPositions();
  }, []);
  return _react.default.createElement(_styles.Wrapper, null, _react.default.createElement(_bricksTheme.default, null), _react.default.createElement(_styles.Container, {
    backgroundColor: backgroundColor?.hex || backgroundColor,
    borderColor: borderColor?.hex || borderColor
  }, fluid && _react.default.createElement(_styles.LogoWrapper, null, _react.default.createElement(_styles.Image, {
    srcSet: fluid.srcSet,
    src: fluid.src
  })), _react.default.createElement(_styles.FormWrapper, null, _react.default.createElement("form", {
    ref: formRef,
    onSubmit: handleSubmit
  }, _react.default.createElement(_styles.FormContainer, null, fields.map((field, index) => _react.default.createElement(_styles.LabelContainer, {
    key: field.name,
    labelMargin: index % 2 === 0
  }, _react.default.createElement(_styles.Label, {
    textColor: textColor?.hex || textColor,
    htmlFor: field.name
  }, field.label), _react.default.createElement(_styles.Input, {
    ref: field.ref,
    id: field.name,
    type: field.name,
    name: field.name,
    pattern: field.pattern.source,
    title: field.errorMessage,
    placeholder: " ",
    onBlur: () => handleInputBlur(field.ref),
    onInput: () => handleInputChange(field.ref),
    textColor: textColor?.hex || textColor,
    borderColor: borderColor?.hex || borderColor,
    required: true
  })))), consentMessage && _react.default.createElement(_styles.CheckboxContainer, null, _react.default.createElement(_styles.Input, {
    id: "consent",
    name: "consent",
    type: "checkbox",
    onChange: handleConsentChange,
    checked: isChecked,
    buttonColor: buttonColor?.hex || buttonColor,
    buttonTextColor: buttonTextColor?.hex || buttonTextColor,
    checkbox: true
  }), _react.default.createElement(_styles.CheckboxParagraph, {
    textColor: textColor?.hex || textColor,
    dangerouslySetInnerHTML: {
      __html: consentMessage
    }
  })), optInOption && _react.default.createElement(_styles.CheckboxContainer, null, _react.default.createElement(_styles.Input, {
    type: "checkbox",
    id: "optin",
    name: "optin",
    onChange: handleOptInChange,
    checked: isOptedIn,
    buttonColor: buttonColor?.hex || buttonColor,
    buttonTextColor: buttonTextColor?.hex || buttonTextColor,
    checkbox: true
  }), _react.default.createElement(_styles.CheckboxParagraph, {
    textColor: textColor?.hex || textColor,
    dangerouslySetInnerHTML: {
      __html: optInMessage
    }
  })), _react.default.createElement(_styles.Button, {
    type: "submit",
    buttonTextColor: buttonTextColor?.hex || buttonTextColor,
    buttonColor: buttonColor?.hex || buttonColor
  }, submitText), _react.default.createElement(_styles.Paragraph, {
    textColor: textColor?.hex || textColor,
    bold: true
  }, result)))));
};
exports.FieldsForm = FieldsForm;
//# sourceMappingURL=index.js.map